/**
 * Copiar texto al clipboard con fallback para contextos no-secure (HTTP).
 *
 * navigator.clipboard.writeText() solo funciona en "secure context"
 * (HTTPS o localhost). En HTTP plano el navegador lo bloquea con error.
 * El fallback usa el método legacy document.execCommand('copy') con un
 * <textarea> oculto.
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  // Camino moderno (HTTPS / localhost)
  if (typeof navigator !== 'undefined' && navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // Fallthrough al método legacy
    }
  }

  // Fallback legacy: textarea oculto + execCommand
  if (typeof document === 'undefined') return false;
  const textarea = document.createElement('textarea');
  textarea.value = text;
  // Evitar saltos al scroll y selección visible
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.top = '0';
  textarea.style.left = '0';
  textarea.style.width = '1px';
  textarea.style.height = '1px';
  textarea.style.opacity = '0';
  textarea.style.pointerEvents = 'none';
  document.body.appendChild(textarea);

  try {
    textarea.focus();
    textarea.select();
    textarea.setSelectionRange(0, text.length);
    return document.execCommand('copy');
  } catch {
    return false;
  } finally {
    document.body.removeChild(textarea);
  }
}
